import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useRef, useState, useEffect } from 'react';
import { IMAGE_ADMIN_PROFILE } from '../../../lib/endpoints/profileImage';
import moment from 'moment';
import { GenderEnum } from '../../../enums/genderEnum';
import { useTranslation } from 'react-i18next';
import { generateImageFileNameWithRandomName } from '../../../utils/generateImageFileName';
import { OFFICER_PROFILE_UPDATE } from '../../../lib/endpoints/officerProfile';
import axios from '../../../lib/axios';

const useAdminDetailController = () => {
  const [imageToShow, setImageToShow] = useState<any>(null!);
  const [imageFile, setImageFile] = useState<any>(null!);
  const [selectedGender, setSelectedGender] = useState<GenderEnum>(GenderEnum.OTHER);
  const [loadingConfirmForm, setLoadingConfirmForm] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);

  const fullName = useRef<HTMLInputElement>(null!);
  const phone = useRef<HTMLInputElement>(null!);
  const email = useRef<HTMLInputElement>(null!);
  const dateOfBirth = useRef<HTMLInputElement>(null!);
  const province = useRef<HTMLInputElement>(null!);
  const city = useRef<HTMLInputElement>(null!);
  const village = useRef<HTMLInputElement>(null!);

  const auth = useSelector((state: RootState) => state?.auth?.data);
  const { t } = useTranslation('global');
  //------- api manage --------//

  const handleUpdateProfile = async () => {
    try {
      setLoadingConfirmForm(true);
      const formData = new FormData();
      formData.append('fullName', fullName.current?.value);
      formData.append('phone', phone.current?.value);
      formData.append('email', email.current?.value);
      formData.append('province', province.current?.value);
      formData.append('city', city.current?.value);
      formData.append(
        'dateOfBirth',
        moment(new Date(dateOfBirth.current.value)).format('DD/MM/YYYY')
      );
      formData.append('village', village.current?.value);
      if (selectedGender) {
        formData.append('gender', selectedGender);
      }
      if (imageFile) {
        formData.append('file', generateImageFileNameWithRandomName(imageFile));
      }

      await axios.patch(OFFICER_PROFILE_UPDATE + auth?.profile?.id, formData);
      setOpenConfirm(false);
      window.alert('Change Profile Admin complete.');
      window.location.reload();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmForm(false);
      setOpenConfirm(false);
    }
  };

  //------- api manage end--------//

  // ------ function ----------//

  const handleSubmit = () => {
    handleUpdateProfile();
  };

  const handleValidateForm = () => {
    if (!/^\d+$/.test(phone.current?.value)) {
      setErrorMessage('Phone number must contain only digits.');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.current?.value)) {
      setErrorMessage('Please enter a valid email address.');
      return false;
    }
    if (!selectedGender) {
      setErrorMessage('Please select a gender.');
      return false;
    }

    if (!dateOfBirth.current?.value) {
      setErrorMessage('Please enter your date of birth.');
      return false;
    }
    if (phone.current?.value.length < 8) {
      setErrorMessage('Phone number must be at least greater than or equal to 8 digits');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleDateChange = () => {
    const inputDate = auth?.profile?.dateOfBirth;
    const dateObject = moment(inputDate, 'DD/MM/YYYY');
    const formattedDate = dateObject.format('YYYY-MM-DD');

    return formattedDate;
  };

  const handleSelectedGender = (e: any) => {
    setSelectedGender(e.target.value);
  };

  const handleSelectedImage = (e: any) => {
    const file = e.target.files[0];
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageToShow(reader.result);
      }
    };
    reader.readAsDataURL(file);
    setImageToShow(file);
  };

  const handleOpenConfirmForm = (e: any) => {
    e.preventDefault();
    if (handleValidateForm()) {
      setOpenConfirm(!openConfirm);
    }
  };

  const handleCloseConfirmForm = () => {
    setOpenConfirm(false);
  };

  // ------ function end----------//

  //------- useEffect --------//
  useEffect(() => {
    if (auth) {
      setImageToShow(IMAGE_ADMIN_PROFILE + auth?.profile?.image?.url);
      fullName.current.value = auth?.profile?.fullName;
      phone.current.value = auth?.profile?.phone;
      email.current.value = auth?.profile?.email;
      dateOfBirth.current.value = handleDateChange();
      province.current.value = auth?.profile?.province;
      city.current.value = auth?.profile?.city;
      village.current.value = auth?.profile?.village;
      setSelectedGender(auth.profile?.gender as GenderEnum);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return {
    auth,
    fullName,
    phone,
    email,
    dateOfBirth,
    province,
    city,
    village,
    imageToShow,
    selectedGender,
    handleSelectedGender,
    handleSelectedImage,
    openConfirm,
    errorMessage,
    loadingConfirmForm,
    handleCloseConfirmForm,
    handleOpenConfirmForm,
    handleSubmit,
  };
};
export default useAdminDetailController;
